// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:30:35

export default {
  "id": "tile-fruits",
  "slug": "tile-fruits",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/df02bbc623bb4c8b8a685025480d30c2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/df02bbc623bb4c8b8a685025480d30c2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tile Fruits",
      "description": "In Tile Fruits, embark on a delectable adventure packed with vibrant fruits and captivating challenges! This 2D tile-matching game tests your strategic prowess as you aim to connect three identical fruits to advance through progressively difficult levels. Each match removes the fruits from the board, but beware: having more than seven different types of fruits on the board at once results in a loss.",
      "instructions": "Playing Tile Fruits is straightforward yet engaging. Simply tap on a fruit to select it, and then match three identical fruits to remove them from the board. As you clear levels, youll face increasing difficulty with new challenges and unique layouts. To ",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "fruits",
        "relax",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "瓦片水果",
      "description": "在《Tile Fruits》中，踏上一段美味的多彩水果冒险之旅！这款2D拼图匹配游戏考验你的策略技巧，你将连接三个相同的水果以通过难度逐渐增加的关卡。每次匹配都会将水果从板上移除，但请注意：同时有超过七种不同的水果在板上会导致失败。",
      "instructions": "玩“Tile Fruits”简单而有趣。只需轻触水果选择它，然后匹配三个相同的水果将它们从板上移除。随着你通过关卡，你将面临越来越高的难度，新的挑战和独特的布局。要",
      "genres": [
        "匹配3"
      ],
      "tags": [
        "水果",
        "放松",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "地塊水果",
      "description": "在《拼圖水果》中，啟航一段美味絕倫的冒險，滿滿充滿生動的水果和吸引人的挑戰！這是一款2D拼圖匹配遊戲，考驗你的策略能力，當你努力連接三個相同的果實來通過逐漸困難的關卡。每次匹配都會將果實從遊戲板上移除，但請注意：同時在遊戲板上超過七種不同的水果會導致失敗。",
      "instructions": "玩Tile Fruits非常簡單卻又引人入勝。只需輕點水果選擇它，然後匹配三個相同的水果將其從遊戲板上移除。隨著你通過關卡，你將面對逐漸增加的難度，新的挑戰和獨特的佈局。要",
      "genres": [
        "匹配3"
      ],
      "tags": [
        "水果",
        "放鬆",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "地瓜果樂",
      "description": "在《Tile Fruits》中，啟程於一場滿載生動水果及吸引挑戰的美食冒險！這是一款2D橋接匹配遊戲，測試你的策略能力，當你試圖連接三個相同的水果以通過逐漸難度的關卡。每次匹配都會將水果從棋盤上移除，但請注意：當棋盤上同時有超過七種不同的水果時，會導致失敗。",
      "instructions": "玩Tile Fruits既簡單又吸引人。只需輕觸水果選擇它，然後匹配三個相同的果實將其從遊戲板中移除。隨著你通過關卡，你將面對越來越高的難度，以及新的挑戰和獨特的佈局。為了",
      "genres": [
        "三消配對"
      ],
      "tags": [
        "水果",
        "放鬆",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "タイルフルーツ",
      "description": "タイルフルーツで、鮮やかな果物と魅力的な挑戦に満ちた美味しい冒険に出発してください！この2Dタイルマッチングゲームでは、同種の果物を3つ結びつけることで段階的に難しくなるレベルを進む際に、あなたの戦略的なスキルを試します。マッチングにより果物がボードから消え去りますが、気をつけてください：一度に7種類以上の果物がボード上にあるとゲームオーバーになります。",
      "instructions": "Tile Fruitsをプレイするのは簡単でありながら楽しい。ただし、果物をタップして選択し、同じ果物を3つ見つけてボードから取り除くだけだ。レベルをクリアしていくにつれて、新しい挑戦やユニークなレイアウトで難度が高くなる。それに",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "果物",
        "リラックス",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "타일프루츠",
      "description": "타일 프루츠에서 생동감 넘치는 열대 과일과 매력적인 도전을 통해 맛있는 모험에 떠나보세요! 이 2D 타일 매칭 게임에서는 세 개의 같은 과일을 연결하여 점점 더 어려운 레벨을 통과하려는 전략적 능력을 테스트합니다. 매치는 보드에서 과일을 제거하지만, 주의하세요: 한 번에 일곱 가지 이상의 다른 종류의 과일이 보드에 있는 경우 패배합니다.",
      "instructions": "타일 프루츠를 플레이하는 것은 간단하지만 흥미롭습니다. 단순히 과일을 탭하여 선택하고, 그런 다음 같은 과일을 세 개로 일치시켜 게임 보드에서 제거합니다. 레벨을 클리어하면서 새로운 도전과 독특한 레이아웃으로 점점 더 어려움을 겪게 됩니다.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "과일",
        "휴식",
        "슬라이딩 패ズル"
      ]
    },
    "fr": {
      "title": "Tuile Fruits",
      "description": "Dans Tile Fruits, embarquez dans une aventure délicieuse remplie de fruits vibrants et de défis captivants ! Ce jeu de correspondance en 2D met à l'épreuve votre habileté stratégique alors que vous cherchez à connecter trois fruits identiques pour avancer à travers des niveaux de plus en plus difficiles. Chaque correspondance supprime les fruits du plateau, mais faites attention : avoir plus de sept types différents de fruits sur le plateau en même temps entraîne une défaite.",
      "instructions": "Jouer à Tile Fruits est simple mais captivant. Il suffit de cliquer sur un fruit pour le sélectionner, puis de former un trio identique pour le supprimer du plateau. À mesure que vous terminez les niveaux, la difficulté augmente avec de nouveaux défis et des configurations uniques. Pour",
      "genres": [
        "Tri-à-coups"
      ],
      "tags": [
        "Fruits",
        "détente",
        "puzzle glissant"
      ]
    }
  }
};
